<script lang="ts">
  import { ArrowUpRight } from 'lucide-svelte';
  import * as Card from '$lib/components/ui/card';
  import type { Tutorial } from 'query-strapi-v4';
  import { getCollectionPermalinkPrefix } from './getCollectionPermalinkPrefix';
  import { Button } from '$lib/components/ui/button';

  type FeaturedImage = {
    width?: number | number;
    src?: string;
    alt?: string | null;
  };

  export let collectionType: string = undefined;
  export let meta: Tutorial['meta'];

  $: slug = meta.slug;
  $: title = meta.title;
  $: subtitle = meta.link_title || collectionType;
  $: description = meta.excerpt;
  $: button = {
    text: `Read ${collectionType}`,
    href: `/${getCollectionPermalinkPrefix(collectionType)}/${slug}`
  };

  // temporarily removed
  $: featuredImage = {
    width: meta.featured_image?.data?.attributes?.width,
    src: meta.featured_image?.data?.attributes?.url,
    alt: meta.featured_image?.data?.attributes?.alternativeText
  };
</script>

<div class="my-8">
  <div class="group relative rounded-lg border p-6 shadow-md transition-shadow hover:shadow-lg">
    <div class="flex flex-col justify-between space-y-4">
      <div class="space-y-2 [&amp;>h3]:!mt-0 [&amp;>h4]:!mt-0 [&amp;>p]:text-muted-foreground">
        <p class="text-primary text-xs capitalize scroll-m-20 font-semibold tracking-tight">
          {subtitle}
        </p>
        <h3 class="text-2xl font-semibold">
          {title}
        </h3>
        <p class="leading-7 text-sm text-muted-foreground">
          {description}
        </p>
      </div>
    </div>
    <div class="absolute top-2 right-2">
      <ArrowUpRight class="h-6 w-6" />
    </div>
    <a class="absolute inset-0" href={button.href}><span class="sr-only">View</span></a>
  </div>
</div>
